import React from 'react';
import { getAssetFieldValue } from 'helpers/AppHelpers';

export function AssetFieldCell({ assetFields, columnId }) {
  return <span>{getAssetFieldValue(assetFields, columnId)}</span>;
}
